import { Component, inject } from '@angular/core';
import { Grow } from '@library';
import { ConcessionsFacade } from '@app/store/concessions/facades/concessions.facade';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'app-payment-concessions',
    templateUrl: './payment-concessions.component.html',
    styleUrls: ['./payment-concessions.component.scss'],
    animations: [Grow],
})
export class PaymentConcessionsComponent {
    private readonly concessionsFacade = inject(ConcessionsFacade);
    readonly paymentConcessions$ = this.concessionsFacade.paymentEndsConcessions$;

    show$ = new BehaviorSubject<boolean>(false);

    toggle() {
        this.show$.next(!this.show$.value);
    }
}
